"use strict";

$(document).ready(function () {
  var page;
  var templateId = $('body').data('template');
  /*
   * Init Nette JS
   */

  $.nette.init();
  /*
  * Init page controller by template
  */

  switch (templateId) {
    case "homepage":
      page = new HomepageController();
      break;

    case "references":
      page = new ReferenceController();
      break;

    default:
      // init generic page controller for other templates
      page = new PageController();
      break;
  }

  var form = new FormComponent();
  var footerComponent = new FooterComponent();
});